import styled from "styled-components"

export const FileWrapper = styled.div`
    position: relative;
    width: 100%;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 2px;
    border: 2px solid ${(props) => props.theme.driveNewFileBorderColor};
`
export const FileStatusWrapper = styled.div`
    position: absolute;
    right: 15px;
    bottom: 15px;
    height: 38px;
    display: flex;
    align-items: center;
`
export const FileStatusLoaderWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 38px;
    width: 38px;

    & > i.fa-spinner {
        height: 24px;
        width: 24px;
        font-size: 24px;
        color: ${(props) => props.theme.driveNewFileInProgressColor};
    }
`
export const FileStatusSuccess = styled.div`
    padding: 0 12px;
    color: ${(props) => props.theme.driveNewFileSuccessColor};
`
export const FileStatusError = styled.div`
    padding: 0 12px;
    color: ${(props) => props.theme.driveNewFileErrorColor};
`
